import React from 'react';
import PageScreenDefault from '../../components/screen/PageScreenDefault';

const New = () => <PageScreenDefault url="new" />;
export default New;
